export default __webpack_public_path__ + "media/images/mailer-new/heading/appeal-rejected-faf26716b7081005a1c2a51dde6ac2a8.png";